import _axios from '@/plugins/axios';
import { CCMError } from '../../../lib/Errors';

export default {
	async getAllCCMAttachmentByPatientId (patientId) {
		const response = await _axios.get(`/ccmattachment/getbypatientid/${patientId}`);
		if (response.data.resFlag) {
			return response.data;
		} else if (response.data.data === null) {
			return [];
		}
		throw new CCMError('Error getting all CCM Attachments by patient ID');
	},
	async getSingleCCMAttachmentByPatientId (patientId, attachmentId) {
		const response = await _axios.get(`/ccmattachment/${patientId}/${attachmentId}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting CCM Attachment by CCM record ID');
	},
	async getCCMAttachment (id) {
		const response = await _axios.get(`/ccmattachment/${id}`, {
			responseType: 'blob',
		});
		if (response.data) {
			return response.data;
		}
		throw new CCMError('Error getting CCM Attachment');
	},
	async addCCMAttachment (body) {
		const response = await _axios.post('/ccmattachment', body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error adding CCM Attachment');
	},
	async deleteCCMAttachment (id) {
		const response = await _axios.delete(`/ccmattachment/${id}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error deleting CCM Attachment');
	},
	async sendAttachmentToAi (fileId) {
		const response = await _axios.post(`/ccmAttachment/sendAttachmentToAi/${fileId}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting AI Summary for Attachment');
	},
};
